module.exports = __webpack_public_path__ + "img/skillsD-1.1cbbe5ab.png";